"use strict";
import { ArrowChangeDown } from "components/Icons/ArrowChangeDown";
import LogoProvider from "components/Logo/LogoProvider";
import { TopazWordmark } from "components/Logo/TopazWordmark";
import { MenuDropdown } from "components/NavBar/CompanyMenu/MenuDropdown";
import { MobileMenuDrawer } from "components/NavBar/CompanyMenu/MobileMenuDrawer";
import { useIsMobileDrawer } from "components/NavBar/ScreenSizes";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Flex, Popover, Text, styled, useMedia } from "ui/src";
import { Hamburger } from "ui/src/components/icons/Hamburger";
import { TestID } from "test/fixtures/testIDs";
const ArrowDownWrapper = styled(Text, {
  color: "$neutral2",
  "$group-hover": { color: "$neutral1" },
  variants: {
    open: {
      true: { color: "$neutral1" }
    }
  }
});
export function CompanyMenu() {
  const popoverRef = useRef(null);
  const media = useMedia();
  const isMobileDrawer = useIsMobileDrawer();
  const isLargeScreen = !media.xxl;
  const showShortBrand = media.xxl && !media.md;
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const closeMenu = useCallback(() => {
    popoverRef.current?.close();
  }, [popoverRef]);
  useEffect(() => closeMenu(), [location, closeMenu]);
  const handleLogoClick = useCallback(() => {
    navigate({ pathname: "/swap", search: "" });
  }, [navigate]);
  const brand = <Flex row alignItems="center" gap="$gap12" onPress={handleLogoClick} data-testid={TestID.NavUniswapLogo}>
      {isLargeScreen || showShortBrand ? <TopazWordmark height={isLargeScreen ? 28 : 24} /> : <LogoProvider size={24} />}
    </Flex>;
  const navIsVisible = !media.xl;
  if (navIsVisible) {
    return <Flex row alignItems="center" cursor="pointer">
        {brand}
      </Flex>;
  }
  return <Popover ref={popoverRef} placement="bottom" hoverable stayInFrame allowFlip onOpenChange={setIsOpen}>
      <Popover.Trigger data-testid={TestID.NavCompanyMenu}>
        <Flex row alignItems="center" gap="$gap4" cursor="pointer" group $platform-web={{ containerType: "normal" }}>
          {brand}
          {media.md && <Hamburger size={24} color="$neutral2" cursor="pointer" ml="8px" />}
          {!media.md && <ArrowDownWrapper open={isOpen}>
              <ArrowChangeDown width="12px" height="12px" />
            </ArrowDownWrapper>}
        </Flex>
      </Popover.Trigger>
      {isMobileDrawer ? <MobileMenuDrawer isOpen={isOpen} closeMenu={closeMenu} /> : <MenuDropdown close={closeMenu} />}
    </Popover>;
}
